<template>
  <ion-page v-if="template?.style">
    <component :is="currentComponent"/>
    <InstallCheckModal :visible="checking" :checking="checking"/>
    <LoadingModal :visible="loading"/>
  </ion-page>
</template>

<script setup lang="ts">
import { IonPage } from '@ionic/vue';
import { shallowRef, watch } from 'vue';
import { useDownloadLogic } from './logic';
import { onMounted, onBeforeUnmount } from 'vue';
import { checkBrowser} from '@/utils/pwa/browser';
import { STYLE_TEMPLATE, STYLE_TEMPLATE_COLOR, StyleKey } from './data';
import InstallCheckModal from './components/InstallCheckModal.vue';
import LoadingModal from './components/LoadingModal.vue';

const currentComponent = shallowRef();
const background = ref('transparent');

const {
  checking,
  systemStore,
  fromUrl,
  template,
  showGoogleInfo,
  loading,
  checkTimer,
  channelStore,
} = useDownloadLogic();

watch(() => template.value?.style, async (value) => {
  if (!value) return;
  console.log(template.value, value, STYLE_TEMPLATE, STYLE_TEMPLATE_COLOR)
  const component = STYLE_TEMPLATE[value as StyleKey]
  currentComponent.value = await defineAsyncComponent(() => import(`./style/${component}.vue`));
  background.value = STYLE_TEMPLATE_COLOR[value as StyleKey];
});

// 生命周期: 页面加载前
onMounted(() => {
  channelStore.getDownloadTemplate(fromUrl.value).then(() => {
    if (template.value?.authentication !== 'custom')
      showGoogleInfo.value = true;
    if (!systemStore.isPwaVisible)
      checkBrowser();
  })
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 5000);
});

// 生命周期: 页面卸载前
onBeforeUnmount(() => {
  clearInterval(checkTimer);
});

</script>

<style scoped>
.ion-page {
  background: v-bind(background);
}
</style>
